import { render, staticRenderFns } from "./FinancialAccountsV4.vue?vue&type=template&id=1aa2a636&scoped=true"
import script from "./FinancialAccountsV4.vue?vue&type=script&lang=js"
export * from "./FinancialAccountsV4.vue?vue&type=script&lang=js"
import style0 from "./FinancialAccountsV4.vue?vue&type=style&index=0&id=1aa2a636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa2a636",
  null
  
)

export default component.exports